import {
  ActivityIndicator,
  Dimensions,
  Modal,
  PixelRatio,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import MoneyIcon from "../../icons/MoneyIcon";
import Colours from "../../utils/Colours";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TransactionCodeSetUpScreen = ({ hideScreen, fromSettings }) => {
  // const [focusedIndex, setFocusedIndex] = useState(0);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);

  const [credits, setCredits] = useState("");

  const [focusedIndex, setFocusedIndex] = useState(null);
  const [focusedIndex2, setFocusedIndex2] = useState(null);
  const [passcode, setPasscode] = useState(null);
  // const [passcode2, setPasscode2] = useState(null)
  const [code, setCode] = useState(["", "", "", ""]);
  const [code2, setCode2] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const inputRefs2 = useRef([]);

  // // Automatically focus on the first input when the page loads
  // useEffect(() => {
  //     inputRefs.current[0]?.focus();
  // }, []);
  const axiosPrivate = useAxiosPrivate();

  // useEffect(() => {
  //     if (passcode2) {
  //         compareAndSubmitCode(passcode2);
  //     }
  // }, [passcode2]);

  useEffect(() => {
    fetchUserMeezaCredit();
  }, []);

  const fetchUserMeezaCredit = async () => {
    setIsLoadings(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.get("/userCredits/userCredits");

      // //console.log('responsexx', response)

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('meeza credit fetched:', response.data);

        setCredits(Number(response.data.meezaCredits).toLocaleString());

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
      } else if (error.request) {
        //console.error('No response received:', error.request);
      } else {
        //console.error('Error setting up the request:', error.message);
      }
    } finally {
      setIsLoadings(false);
    }
  };

  const handleChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      // Only allow a single digit
      const newCode = [...code];
      newCode[index] = text;
      setCode(newCode);

      // Move to the next input if a digit is entered
      if (text && index < 3) {
        inputRefs.current[index + 1]?.focus();
      }

      if (index === 3 && text) {
        const passcode = newCode.join("");
        setPasscode(passcode);
        //console.log('passcode', passcode)
        setTimeout(() => {
          // hideScreen(); // Close modal
        }, 500);
      }
    }
    //console.log('text', text)
  };

  const handleChange2 = (text, index) => {
    if (/^\d?$/.test(text)) {
      // Only allow a single digit
      const newCode2 = [...code2];
      newCode2[index] = text;
      setCode2(newCode2);

      // Move to the next input if a digit is entered
      if (text && index < 3) {
        inputRefs2.current[index + 1]?.focus();
      }

      if (index === 3 && text) {
        const passcode2 = newCode2.join("");
        // setPasscode2(passcode2)
        // //console.log('passcode2', passcode2)
        compareAndSubmitCode(passcode2);
      }
    }
    //console.log('text2', text)
  };

  const handleKeyPress = ({ nativeEvent }, index) => {
    if (nativeEvent.key === "Backspace" && !code[index] && index > 0) {
      // Move to the previous input on delete
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleKeyPress2 = ({ nativeEvent }, index) => {
    if (nativeEvent.key === "Backspace" && !code2[index] && index > 0) {
      // Move to the previous input on delete
      inputRefs2.current[index - 1]?.focus();
    }
  };
  const compareAndSubmitCode = async (passcode2) => {
    if (passcode !== passcode2) {
      setErrorMessage("Make sure both transaction codes are equal");
      setIsErrorCompVisible(true);
      return;
    }

    // if (passcode === passcode2) {
    //submit to the database, recieve a response and send notification to user

    try {
      setIsLoading(true);
      const response = await axiosPrivate.post("/passcode/passcode", { passcode });
      if (response.status === 200 || response.status === 201) {
        setSuccessMessage(
          fromSettings ? "Transaction code updated successfully !" : response.data.message,
        );
        setIsSuccessCompVisible(true);
      } else {
        //console.error('Unexpected response:', response.data);
        setErrorMessage("Unexpected response");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
        const errorMessages =
          error.response.data?.error || error.response.data?.message || "Something went wrong";
        setErrorMessage(errorMessages);
        setIsErrorCompVisible(true);
      } else if (error.request) {
        //console.error('No response received:', error.request);
        setErrorMessage("No response Recieved check your internet");
        setIsErrorCompVisible(true);
      } else {
        //console.error('Error setting up the request:', error.message);
        setErrorMessage(error.message || "Unexpected error occurred");
        setIsErrorCompVisible(true);
      }
    } finally {
      setIsLoading(false);
    }

    // }
  };

  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <View>
      {!fromSettings && (
        <View style={styles.textboxAmountContainer}>
          <View style={styles.textboxHeader}>
            <Text style={styles.meezaCreditBalanceTxt}>Meeza Credit Balance</Text>
          </View>

          <View style={styles.tableAmountContainer}>
            <MoneyIcon
              color={Colours.PRIMARY_LIGHT}
              width={dynamicSize(30)}
              height={dynamicSize(30)}
            />
            <Text style={styles.creditsTxt}>Credits:</Text>
            {isLoadings ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <>
                {/* <Text style={styles.creditsValueTxt}>{isReverified ? credits : "**** "}</Text> */}
                <Text style={styles.creditsValueTxt}>{credits}</Text>
                {/* {isReverified ? "" :
                                <TouchableOpacity
                                    onPress={() => { setShowUsernamePasswordTransactCode(true) }}
                                >
                                    <ViewMoreIcon color={Colours.MIDGRAY} />
                                </TouchableOpacity>
                            } */}
              </>
            )}
          </View>
        </View>
      )}

      <View style={styles.textboxAmountContainer}>
        <View style={styles.textboxHeader}>
          <Text style={styles.doingsAmtTxt}>Enter Code </Text>
          <Text style={styles.demacation}>| :</Text>
        </View>

        <View style={styles.textBoxContainer}>
          {code.map((digit, index) => (
            <AppTextInput
              key={index}
              ref={(ref) => (inputRefs.current[index] = ref)}
              style={[styles.inputTxt, focusedIndex === index && styles.focusedBorder]}
              keyboardType="numeric"
              maxLength={1} // Only allow one character
              value={digit}
              onChangeText={(text) => handleChange(text, index)}
              onKeyPress={(e) => handleKeyPress(e, index)}
              onFocus={() => setFocusedIndex(index)}
              onBlur={() => setFocusedIndex(null)}
              textAlign="center"
              secureTextEntry={true}
            />
          ))}

          <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1 }}></View>
          <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(30)} width={dynamicSize(30)} />
        </View>
      </View>

      <View style={styles.textboxAmountContainer}>
        <View style={styles.textboxHeader}>
          <Text style={styles.doingsAmtTxt}>Re-enter Code </Text>
          <Text style={styles.demacation}>| :+</Text>
        </View>

        <View style={styles.textBoxContainer}>
          {code2.map((digit, index) => (
            <AppTextInput
              key={index}
              ref={(ref) => (inputRefs2.current[index] = ref)}
              style={[styles.inputTxt, focusedIndex2 === index && styles.focusedBorder]}
              keyboardType="numeric"
              maxLength={1} // Only allow one character
              value={digit}
              onChangeText={(text) => handleChange2(text, index)}
              onKeyPress={(e) => handleKeyPress2(e, index)}
              onFocus={() => setFocusedIndex2(index)}
              onBlur={() => setFocusedIndex2(null)}
              textAlign="center"
              secureTextEntry={true}
            />
          ))}

          <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1 }}></View>
          <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(30)} width={dynamicSize(30)} />
        </View>
      </View>
      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>

      <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setIsSuccessCompVisible(false);
            hideScreen();
          }}
        />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  textboxAmountContainer: {
    margin: dynamicSpacing(15),
    marginBottom: dynamicSpacing(40),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
  },
  textboxHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(1),
  },
  //    textboxHeader: {
  //     display: 'flex',
  //     flexDirection: 'row',
  //     alignItems: 'center',
  //     gap: dynamicSpacing(1),
  // },
  meezaCreditBalanceTxt: {
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },
  tableAmountContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
    marginBottom: dynamicSpacing(10),
  },
  creditsTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  creditsValueTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(20),
    fontFamily: "Sen-Bold",
  },

  doingsAmtTxt: {
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Bold",
  },
  demacation: {
    paddingLeft: dynamicSpacing(1),
    paddingBottom: dynamicSpacing(0),
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Regular",
  },
  textBoxContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(10),
  },
  inputTxt: {
    height: dynamicSize(40),
    width: dynamicSize(50),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(20),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(10),
    marginRight: dynamicSpacing(10),
  },
  buttonGray: {
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(10),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
    borderWidth: dynamicSize(2),
  },
});

export default TransactionCodeSetUpScreen;
